import { StyledSearchResult } from '@/components/styles'
import genLinkParams from '@/lib/generateLinkParams'
import { ArrowButton } from '@/components'
import Link from 'next/link'

export default function SearchResult(props) {
  // Page types: specialist, service, direction, subdirection, article, encyclopedia, promo
  const { title, content, page_type: type, slug, direction } = props
  const directionSlug = direction?.slug

  const [href, as, tag] = genLinkParams({ type, slug, parentSlug: directionSlug })

  return (
    <StyledSearchResult>
      <Link href={href} as={as} passHref>
        <StyledSearchResult.Link />
      </Link>

      <StyledSearchResult.Bg />

      <StyledSearchResult.Arrow>
        <ArrowButton />
      </StyledSearchResult.Arrow>

      <StyledSearchResult.Content>
        <StyledSearchResult.Tag>{tag}</StyledSearchResult.Tag>

        {title && <StyledSearchResult.Title>{title}</StyledSearchResult.Title>}

        {content && (
          <StyledSearchResult.Description
            dangerouslySetInnerHTML={{ __html: content }}
          ></StyledSearchResult.Description>
        )}
      </StyledSearchResult.Content>
    </StyledSearchResult>
  )
}
